export type CsvTemplateType = 'destination' | 'transfer';

const TEMPLATE_HEADERS: Record<CsvTemplateType, string[]> = {
	destination: [
		'Documento',
		'Nome do beneficiario',
		'Tipo de Movimentacao',
		'Tipo de chave',
		'Chave Pix',
		'Tipo de Conta',
		'ISPB',
		'Agencia',
		'Conta',
	],
	transfer: [
		'ID',
		'Documento',
		'Nome do beneficiario',
		'Tipo de Movimentacao',
		'Tipo de chave',
		'Chave Pix',
		'Tipo de Conta',
		'ISPB',
		'Agencia',
		'Conta',
		'Valor',
		'Data Agendamento',
		'Descricao',
	],
};

const TEMPLATE_FILENAMES: Record<CsvTemplateType, string> = {
	destination: 'template_importacao.csv',
	transfer: 'template_importacao_transferencia.csv',
};

export const downloadCsvTemplate = (type: CsvTemplateType) => {
	const csvContent = TEMPLATE_HEADERS[type].join(';');

	const blob = new Blob([csvContent], {
		type: 'text/csv;charset=utf-8;',
	});

	const url = window.URL.createObjectURL(blob);

	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', TEMPLATE_FILENAMES[type]);

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
